/**
 * appLinks — statische Client-SSOT der Launchpad-Kachel-Metadaten (id/label/
 * description/image). Build-AGNOSTISCH: ein Build-Artefakt für alle Umgebungen,
 * KEIN Env-Inlining.
 *
 * Ab P1b ist der Kachel-Klick ein SSO-Handoff (`<form method="POST"
 * action="/api/sso/handoff">` mit hidden `target`), KEIN `<a href>` mehr. Die
 * Handoff-ZIELE (Consumer-Origins) leben ab jetzt AUSSCHLIESSLICH server-seitig
 * in `sso-targets.ts` (Mint-Whitelist + form-action-CSP) — der Client kennt nur
 * noch die `id` (= `target`), nicht die Origin (D-P1b-3). Kein `href`, keine
 * Origin-Map hier.
 */
export type AppLinkId = 'dam' | 'transfer';

export interface AppLink {
  id: AppLinkId;
  label: string;
  description: string;
  /** Card-Vorschaubild (public/tools/*.jpg), von tools statisch ausgeliefert. */
  image: string;
}

const META: Record<AppLinkId, { label: string; description: string; image: string }> = {
  dam: {
    label: 'GREENFORCE Assets',
    description:
      'Digital Asset Management Tool. Bilder, Grafiken, Videos – alles an einem Platz.',
    image: '/tools/dam-preview.jpg',
  },
  transfer: {
    label: 'GREENFORCE Transfer',
    description:
      'Dateien hochladen und sicher intern und extern per Link teilen. Volle Kontrolle über geteilte Links.',
    image: '/tools/transfer-preview.jpg',
  },
};

const ORDER: AppLinkId[] = ['dam', 'transfer'];

/** Liefert die Launchpad-Kachel-Metadaten in fixer Reihenfolge. */
export function getAppLinks(): AppLink[] {
  return ORDER.map((id) => ({
    id,
    label: META[id].label,
    description: META[id].description,
    image: META[id].image,
  }));
}

/**
 * Type-Guard für den `app`-Query-Param (P1c Auto-Handoff, Must 2): validiert
 * gegen dieselbe Client-Whitelist wie der Launchpad. Client-Stufe des
 * `app`-Whitelist-Layers (D-P1c-6) — Mint (`isSsoAudience`) + Consumer (aud)
 * bleiben authoritative. Aus `ORDER` abgeleitet → kein Drift bei neuen Apps.
 */
export function isAppLinkId(v: unknown): v is AppLinkId {
  return typeof v === 'string' && (ORDER as string[]).includes(v);
}

/** Anzeige-Label einer App-Id (z. B. „Weiterleitung zu GREENFORCE Assets …"). */
export function appLinkLabel(id: AppLinkId): string {
  return META[id].label;
}
